export default __webpack_public_path__ + "static/media/right_lock_icon.a75927b5.svg";